


















import Vue, { PropType } from 'vue';

const textType = ['round', 'radius', 'square'];

export default Vue.extend({
  name: 'GSelectContactButton',
  props: {
    name: {
      type: String as PropType<string>,
    },
    value: {
      type: Number as PropType<number>,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    text: {
      type: String as PropType<string>,
      validator: (prop: string) => textType.includes(prop),
      default: 'square',
    },
  },
});
